customElements.define("sticky-atc", class StickyAtc extends HTMLElement{
    constructor(){
        super()

        this.regularForm = document.querySelector('.product__info-wrapper .product-form')
        this.variantTogglers = this.querySelector('.sticky-atc__form-wrapper__toggler')
        this.variantRadios = this.querySelector(".sticky-atc__form-wrapper__toggler + variant-radios")
        this.sizeSelectors = this.querySelectorAll('.product-form__input-wrapper label')
        this.stickyInner = this.querySelector('.sticky-atc__inner')
        this.stickyTopRow = this.querySelector('.sticky-atc__top-row')
        this.originalSzbVfrBtnsParent = null
        this.stickyTitle = this.querySelector('.sticky-atc__title-wrapper')
        this.mainProductTitle = document.querySelector('.product__title')
        this.isVisible = false
        this.scrollTimeout = null

        // Initialize as hidden on desktop, visible on mobile
        if (window.innerWidth > 990) {
            this.classList.add("hide");
        }

        // Add debounced scroll handler to prevent jumping
        window.addEventListener("scroll", () => {
            if (this.scrollTimeout) {
                clearTimeout(this.scrollTimeout);
            }
            
            this.scrollTimeout = setTimeout(() => {
                this.handleScroll();
            }, 10); // Small timeout to debounce
        });

        this.variantTogglers.addEventListener("click", ()=>{
            this.variantRadios.classList.toggle("shown")
            this.querySelector('.sticky-atc__inner').classList.toggle('sticky-atc__inner--variants-opened')
        })

        this.sizeSelectors.forEach(label=>{
            if(window.innerWidth > 990)return
            label.addEventListener("click", (e)=>{
                console.log(e.target)
                if(e.target.classList.contains("disabled") || e.target.parentElement.classList.contains("disabled")){
                    return
                }
                setTimeout(()=>{
                    this.querySelector(".product-form__submit").removeAttribute("disabled")
                    this.querySelector(".product-form__submit").click()
                    this.variantRadios.classList.toggle("shown")
                    this.querySelector('.sticky-atc__inner').classList.toggle('sticky-atc__inner--variants-opened')
                },0)
            })
        })
        
        // Initial check
        this.handleScroll();
    }

    handleScroll() {
        // Handle sticky title visibility on mobile
        if (window.innerWidth <= 990 && this.stickyTitle && this.mainProductTitle) {
            const mainTitleRect = this.mainProductTitle.getBoundingClientRect();
            const stickyBarHeight = this.stickyInner?.offsetHeight || 0;
            
            // If we've scrolled past the title (top is negative), hide the sticky title
            if (mainTitleRect.top < 0) {
                this.stickyTitle.style.display = 'none';
            } else {
                // We haven't scrolled past the title yet
                // Check if main title is visible, accounting for sticky bar at bottom
                const adjustedViewportBottom = window.innerHeight - stickyBarHeight;
                const mainTitleVisible = 
                    mainTitleRect.top < adjustedViewportBottom && 
                    mainTitleRect.bottom > 0;
                
                this.stickyTitle.style.display = mainTitleVisible ? 'none' : '';
            }
        }
        
        // Handle sticky form visibility with different logic for mobile vs desktop
        const szbVfrBtns = document.querySelector('.szb-vfr-btns');
        const formVisible = checkVisible(this.regularForm, 0); // Add buffer zone
        
        if (window.innerWidth <= 990) {
            // Mobile: Always show the sticky bar
            if (!this.isVisible) {
                this.isVisible = true;
                this.classList.remove("hide");
            }
        } else {
            // Desktop: Only show when form is not visible
            if (!formVisible && !this.isVisible) {
                this.isVisible = true;
                this.classList.remove("hide");
            } else if (formVisible && this.isVisible) {
                this.isVisible = false;
                this.classList.add("hide");
                this.variantRadios.classList.remove("shown");
                this.stickyInner.classList.remove('sticky-atc__inner--variants-opened');
            } else if (formVisible && !this.isVisible) {
                // Ensure it stays hidden when form is visible
                this.classList.add("hide");
            }
        }
    }
})

function checkVisible(elm, buffer = 0) {
    if (!elm) return false;
    
    var rect = elm.getBoundingClientRect();
    var viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    var stickyBarHeight = document.querySelector('.sticky-atc__inner')?.offsetHeight || 0;
    
    // Add buffer zone to prevent flickering and adjust for sticky bar
    return (!(rect.bottom < 0 + buffer || rect.top - (viewHeight - stickyBarHeight) >= 0 - buffer));
}